import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e4b3221"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "color-grid-memory"
};
const _hoisted_2 = ["disabled", "onClick"];
const _hoisted_3 = {
  key: 0,
  class: "cell-order"
};
const _hoisted_4 = {
  key: 0,
  class: "toolbar"
};
const _hoisted_5 = {
  key: 2,
  class: "stage-text"
};
const _hoisted_6 = {
  key: 3,
  class: "stage-text"
};
const _hoisted_7 = {
  key: 1,
  class: "answer-sequence"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tag = _resolveComponent("el-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "grid-board",
    style: _normalizeStyle({
      gridTemplateColumns: `repeat(${$props.size}, 1fr)`
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cells, cell => {
    return _openBlock(), _createElementBlock("button", {
      key: cell,
      type: "button",
      class: _normalizeClass(["grid-cell", {
        active: $data.activeCell === cell,
        clickable: $data.stage === 'answering' && !$props.reviewMode
      }]),
      style: _normalizeStyle($options.cellStyle(cell)),
      disabled: $props.reviewMode || $data.stage !== 'answering',
      onClick: $event => $options.onCellClick(cell)
    }, [$options.answerOrderMap[cell] != null ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($options.answerOrderMap[cell] + 1), 1)) : _createCommentVNode("", true)], 14, _hoisted_2);
  }), 128))], 4), !$props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_4, [$data.stage === 'idle' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    type: "primary",
    onClick: $options.startPlayback
  }, {
    default: _withCtx(() => [_createTextVNode("开始播放")]),
    _: 1
  }, 8, ["onClick"])) : $data.stage === 'answering' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createVNode(_component_el_button, {
    onClick: $options.undoLast,
    disabled: $data.answers.length === 0
  }, {
    default: _withCtx(() => [_createTextVNode("撤销上一步")]),
    _: 1
  }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
    onClick: $options.clearAnswers,
    disabled: $data.answers.length === 0
  }, {
    default: _withCtx(() => [_createTextVNode("清空重答")]),
    _: 1
  }, 8, ["onClick", "disabled"])], 64)) : $data.stage === 'playing' ? (_openBlock(), _createElementBlock("span", _hoisted_5, "播放中，请记忆红色格子位置")) : $data.stage === 'done' ? (_openBlock(), _createElementBlock("span", _hoisted_6, "作答完成，请点击右下角继续")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !$props.reviewMode && $data.answers.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.answers, (cell, index) => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: `answer_${index}_${cell}`
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(Math.floor(cell / $props.size) + 1) + "-" + _toDisplayString(cell % $props.size + 1), 1)]),
      _: 2
    }, 1024);
  }), 128))])) : _createCommentVNode("", true)]);
}